import React from 'react'
import classNames from 'classnames'
import './PickerPointer.scss'

const PickerPointer = ({ color, isSlider }) => {

  return (
    <div
      className={classNames(
        'viso-color-picker-pointer',
        isSlider && 'viso-color-picker-pointer--slider'
      )}
      style={{ backgroundColor: color }}
    />

  )
}

export default PickerPointer